(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sip-boost-initial-html"] && !Shopify.designMode) return;
  try {
    function sipBoostInitialHtmlStart(root) {
    root.querySelectorAll('[data-sip-boost-html]').forEach((initial) => {
      if (initial.dataset.sipStarted) return;
      initial.dataset.sipStarted = 'true';
      const host = initial.closest('.sip-boost-host');
      if (!host) return;
      const isDefaultView = () => [...new URLSearchParams(location.search).keys()].every((key) => key === 'page' || key === 'preview_theme_id' || key === '_fd' || key === '_sc' || key.startsWith('utm_') || ['gclid', 'fbclid', 'msclkid'].includes(key));
      const removeListingSchema = () => {
        const script = initial.querySelector('[data-sip-boost-schema] script');
        if (!script || script.dataset.sipListRemoved) return;
        try {
          const schema = JSON.parse(script.textContent);
          schema['@graph'] = schema['@graph'].filter((node) => node['@type'] !== 'ItemList');
          schema['@graph'].forEach((node) => { if (node['@type'] === 'CollectionPage') delete node.mainEntity; });
          script.dataset.sipListRemoved = 'true';
          script.textContent = JSON.stringify(schema);
        } catch (_) { script.remove(); }
      };
      if (!isDefaultView()) {
        removeListingSchema();
        initial.hidden = true;
        host.dataset.sipBoostState = 'bypassed';
        return;
      }
      let observer;
      let listingMatched = false;
      const listingScope = '.boost-sd__filter-product-list, .boost-sd__product-list, .boost-sd__product-item';
      const changesListing = (record) => [...record.addedNodes, ...record.removedNodes].some((node) =>
        node.nodeType === 1 && (node.matches(listingScope) || node.querySelector(listingScope))
      );
      const takeover = () => {
        if (!isDefaultView()) {
          removeListingSchema();
          initial.hidden = true;
          host.dataset.sipBoostState = 'bypassed';
          observer?.disconnect();
          return true;
        }
        const cards = [...host.querySelectorAll('.boost-sd__filter-product-list .boost-sd__product-item')];
        const count = host.querySelector('.boost-sd__toolbar-item--product-count');
        const emptyReady = initial.dataset.productIds === '' && count && count.textContent.match(/\d+/)?.[0] === '0';
        if ((!cards.length && !emptyReady) || !cards.every((card) => card.querySelector('a[href*="/products/"]'))) return false;
        const ids = cards.map((card) => card.dataset.productId).join(',');
        listingMatched = ids === initial.dataset.productIds;
        host.dataset.sipBoostState = listingMatched ? 'matched' : 'updated';
        initial.hidden = true;
        if (!isDefaultView() || ids !== initial.dataset.productIds) {
          removeListingSchema();
          observer?.disconnect();
        }
        return true;
      };
      observer = new MutationObserver((records) => {
        // Once matched, ratings and wishlist updates cannot change the listing IDs.
        if (listingMatched && isDefaultView()) {
          if (!records.some(changesListing)) return;
          // A replacement may arrive before its product links; watch until ready again.
          listingMatched = false;
        }
        takeover();
      });
      observer.observe(host, { childList: true, subtree: true });
      takeover();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => sipBoostInitialHtmlStart(document));
  else sipBoostInitialHtmlStart(document);
  document.addEventListener('shopify:section:load', (event) => sipBoostInitialHtmlStart(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sip-sale-badge-priority"] && !Shopify.designMode) return;
  try {
    function sipStartSaleBadgePriority() {
    const root = document.body;
    if (!root || root.hasAttribute('data-sip-sale-badge-priority')) return;
    root.setAttribute('data-sip-sale-badge-priority', '');
    const cardSelector = '.boost-sd__product-item, .limespot-recommendation-box-item, .boost-sd__suggestion-queries-item--product, .swym-storefront-layout-grid-item';
    const labelSelector = '.ls-sale-sign-wrap, .ls-sale-sign-wrap *, [class*="badge"], [class*="label"], [data-sip-new-badge]';
    const productReads = new Map();
    const cardChecks = new WeakMap();
    const productUrl = (card) => {
      const link = card.querySelector('a[href*="/products/"]');
      if (!link) return null;
      try {
        const url = new URL(link.href, location.origin);
        if (url.origin !== location.origin || !/\/products\/[a-z0-9][a-z0-9-]*\/?$/i.test(url.pathname)) return null;
        url.pathname = url.pathname.replace(/\/$/, '') + '.js';
        url.search = '';
        url.hash = '';
        return url.href;
      } catch (_) {
        return null;
      }
    };
    const readCompareAt = (url) => {
      if (!productReads.has(url)) {
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 8000);
        const request = fetch(url, { credentials: 'same-origin', signal: controller.signal })
          .then((response) => {
            if (!response.ok) throw new Error('Product pricing unavailable');
            return response.json();
          })
          .then((product) => Number(product.compare_at_price_max) > 0 ||
            (Array.isArray(product.variants) && product.variants.some((variant) => Number(variant.compare_at_price) > 0)))
          .finally(() => clearTimeout(timeout));
        productReads.set(url, request);
        request.catch(() => productReads.delete(url));
      }
      return productReads.get(url);
    };
    const syncCard = (card) => {
      if (!card.isConnected) return;
      let hasCompareAt = false;
      if (card.matches('.limespot-recommendation-box-item')) {
        hasCompareAt = Number(card.getAttribute('data-original-price')) > 0;
        card.querySelectorAll(labelSelector).forEach((label) => {
          label.toggleAttribute('data-sip-new-badge', label.textContent.trim().toLowerCase() === 'new');
        });
      } else if (card.matches('.boost-sd__product-item')) {
        try {
          const product = JSON.parse(card.getAttribute('data-product'));
          hasCompareAt = Number(product.compareAtPriceMax) > 0 || Number(product.compareAtPriceMin) > 0;
        } catch (_) {
          hasCompareAt = false;
        }
      } else {
        const comparePrice = card.querySelector('.boost-sd__format-currency--price-compare, .swym-storefront-layout-grid-item-compare-price');
        const compareText = comparePrice ? comparePrice.textContent.trim() : '';
        hasCompareAt = Number(card.getAttribute('data-compare-at-price')) > 0 ||
          Number(compareText.replace(/[^0-9.-]/g, '')) > 0;
        let hasNewBadge = false;
        card.querySelectorAll(labelSelector).forEach((label) => {
          const isNew = label.textContent.trim().toLowerCase() === 'new';
          label.toggleAttribute('data-sip-new-badge', isNew);
          hasNewBadge = hasNewBadge || isNew;
        });
        const url = !hasCompareAt && hasNewBadge ? productUrl(card) : null;
        const key = url && url + '|' + compareText;
        let state = cardChecks.get(card);
        if (key && (!state || state.key !== key)) {
          state = { key, pending: true, hasCompareAt: false };
          cardChecks.set(card, state);
          const check = state;
          readCompareAt(url).then((result) => {
            if (!card.isConnected || cardChecks.get(card) !== check) return;
            check.pending = false;
            check.hasCompareAt = result;
            syncCard(card);
          }, () => {
            if (!card.isConnected || cardChecks.get(card) !== check) return;
            check.pending = false;
            check.failed = true;
            syncCard(card);
          });
        } else if (!key) {
          cardChecks.delete(card);
          state = null;
        }
        hasCompareAt = hasCompareAt || !!(state && state.hasCompareAt);
        card.toggleAttribute('data-sip-badge-price-pending', !!(state && (state.pending || state.failed)));
      }
      card.toggleAttribute('data-sip-has-compare-at', hasCompareAt);
    };
    const collectCards = (node, cards) => {
      if (!(node instanceof Element)) return;
      const card = node.closest(cardSelector);
      if (card) cards.add(card);
      node.querySelectorAll(cardSelector).forEach((item) => cards.add(item));
    };
    root.querySelectorAll(cardSelector).forEach(syncCard);
    const observer = new MutationObserver((records) => {
      const cards = new Set();
      records.forEach((record) => {
        const target = record.target instanceof Element ? record.target : record.target.parentElement;
        const card = target && target.closest(cardSelector);
        if (card) cards.add(card);
        record.addedNodes.forEach((node) => collectCards(node, cards));
      });
      cards.forEach(syncCard);
    });
    observer.observe(root, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['data-product', 'data-original-price', 'data-compare-at-price', 'href']
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sipStartSaleBadgePriority, { once: true });
  } else {
    sipStartSaleBadgePriority();
  }
  } catch(e) { console.error(e); }
})();

})();
